import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Button } from '../../../Button/Button';
import { Modal, ModalRef } from '../../../Modal/Modal';

import './PromoDetailsModal.css';

type PromoDetailsModalProps = {
  title: string;
  description: string;
  ctaLabel?: string;
  image: string;
  onCtaClick?: () => void;
};

export const PromoDetailsModal: React.ForwardRefExoticComponent<
  PromoDetailsModalProps & React.RefAttributes<ModalRef>
> = forwardRef(
  ({ ctaLabel, description, image, title, onCtaClick }, forwardedRef) => {
    const modalRef = useRef<ModalRef>(null);

    useImperativeHandle(forwardedRef, () => ({
      openModal: modalRef.current!.openModal,
      closeModal: modalRef.current!.closeModal,
    }));

    return (
      <Modal hasClose ref={modalRef}>
        <h3 className="modal-title">{title}</h3>
        <div className="promo-details--image-container">
          <img className="promo-details--image" src={image} />
        </div>
        <p className="modal-description">{description}</p>
        {ctaLabel && onCtaClick && (
          <div className="modal-button-container">
            <Button onClick={onCtaClick} label={ctaLabel} isPrimary />
          </div>
        )}
      </Modal>
    );
  }
);
